import request from "@/utils/request";

export function getCustomerContri(params) {
  return request({
    url: "/trade/order/customer/top",
    method: "get",
    params,
  });
}
